(function (document, $) {
    $(function () {
        //$(document).on('click', '.js-filter', function (e) {
        //    e.preventDefault();
        //    var filterId = $(this).data('filter-id');
        //    $('input[name=filter]').val(filterId);
        //    $('input[name=page]').val('');
        //    $(this).parents('form').submit();
        //});
        //$(document).on('click', '.js-filter-clear', function (e) {
        //    e.preventDefault();
        //    $('input[name=filter]').val('');
        //    $('input[name=page]').val('');
        //    $(this).parents('form').submit();
        //});
        //$(document).on('click', '.js-filter-archive', function (e) {
        //    e.preventDefault();
        //    var $archive = $('input[name=archive]');
        //    $archive.val($archive.val() === 'true' ? 'false' : 'true');
        //    $('input[name=page]').val('');
        //    $(this).parents('form').submit();
        //});
        //$(document).on('click', '.js-pager', function (e) {
        //    //e.preventDefault();
        //    var page = $(this).data('page');
        //    $('input[name=page]').val(page);
        //    $(this).parents('form').submit();
        //});
        
        $(document).on("click", ".our-people__load-more", function(){
            if ($(this).hasClass("our-people__load-more--expanded")) {
                $(".our-people .row--extra").slideUp();
                $(this).text("Laad meer");
                $(this).removeClass("our-people__load-more--expanded");
            } else {
                $(".our-people .row--hidden").slideDown();
                $(this).text("Laad minder");
                $(this).addClass("our-people__load-more--expanded");
            }
        });
        
        let filtersCollapsed = false;
        
        $(document).ready(function(){
            if ($(".filters").length) {
                let screenWidth = $(window).width();
                const mobileView = 992;

                collapseAllFilters(screenWidth, mobileView);

                let resizeTimer;

                $(window).resize(function () {
                    clearTimeout(resizeTimer);

                    resizeTimer = setTimeout(function () {
                        screenWidth = $(window).width();

                        collapseAllFilters(screenWidth, mobileView);
                    }, 200);
                });
            }
        });
        
        function collapseAllFilters(screenWidth, threshold) {
            if (screenWidth < threshold) {
                if (!filtersCollapsed) {
                    filtersCollapsed = true;

                    $(".filters__group").each(function () {
                        if ($(this).find("[class^='js-filter-collapse-input-']").length) {
                            $(this).find("[class^='js-filter-collapse-input-']").val("true");
                            $(this).find(".filters__options").css("display", "none");
                            $(this).find(".filters__title .fa-minus").removeClass("fa-minus").addClass("fa-plus");
                        }
                    });
                }
            } else {
                filtersCollapsed = false;
            }
        }
    });
})(document, jQuery);